import { render, staticRenderFns } from "./RequirementsTable.vue?vue&type=template&id=6fbcafbb&"
import script from "./RequirementsTable.vue?vue&type=script&lang=js&"
export * from "./RequirementsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports